const WarehouseCategory = `
  id
  description
  weightPacked
`;

export default WarehouseCategory;
